import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import RecoilCardModal from "../../components/modal/RecoilCardModal";
import RecoilCouponModal from "../../components/modal/RecoilCouponModal";
import RecoilStampCouponModal from "../../components/modal/RecoilStampCouponModal";
import CardController, { CardType } from "../../controller/CardController";
import { useToast } from "../../controller/ToastController";
import UserController, {
  CouponType,
  LocationType,
  PositionContextType,
} from "../../controller/UserController";
import { CardModalType, cardModalState } from "../../recoil/cardModal";
import { orderDetailOptionType, orderDetailRealmType } from "../../recoil/cart";
import { CouponModalType, couponModalState } from "../../recoil/couponModal";
import {
  StampCouponModalType,
  stampCouponModalState,
} from "../../recoil/stampCouponModal";
import AsyncLocalStorage from "../../util/AsyncLocalStorage";
import StoreController, { StoreType } from "../../controller/StoreController";
import OrderController from "../../controller/OrderController";
import Spinner from "../../components/ccOS/Spinner";
import { SynthesisResult } from "microsoft-cognitiveservices-speech-sdk";

const speechsdk = require("microsoft-cognitiveservices-speech-sdk");

const OrderPayment = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const location = useLocation();

  const chat = location.state?.chat;

  const { position } = useOutletContext<PositionContextType>();

  const [isLoading, setIsLoading] = useState<boolean>(false); // 데이터 로딩

  const [arrivalTime, setArrivalTime] = useState<string | undefined>();
  const [cards, setCards] = useState<CardType[]>([]);
  const [stamps, setStamps] = useState<boolean[]>();
  const [coupons, setCoupons] = useState<CouponType[]>([]);
  const [stampCoupons, setStampCoupons] = useState<CouponType[]>([]);
  const [point, setPoint] = useState<number>(0);
  const [pointAvailable, setPointAvailable] = useState<boolean>(false);

  const [usingCard, setUsingCard] = useState<CardType>();
  const [usingCoupon, setUsingCoupon] = useState<CouponType>();
  const [usingStamp, setUsingStamp] = useState<any>();
  const [usingPoint, setUsingPoint] = useState<string>("");
  const [discount, setDiscount] = useState<number>(0);

  const [storeId, setStoreId] = useState<number>(0);

  const [cardOpen, setCardOpen] = useRecoilState<CardModalType>(cardModalState);
  const [couponOpen, setCouponOpen] =
    useRecoilState<CouponModalType>(couponModalState);
  const [stampCouponOpen, setStampCouponOpen] =
    useRecoilState<StampCouponModalType>(stampCouponModalState);

  const [cart, setCart] = useState<orderDetailRealmType[]>([]);

  const [isGuide, setIsGuide] = useState<boolean>(false);

  const [storeInfo, setStoreInfo] = useState<StoreType>();

  // const [iframePay, setIframePay] = useState<string>("false");

  // const [ttsInstance, setTtsInstance] = useState<any>(null); // ttsInstance

  // const getCartName = () => {
  //   if (cart.length > 0) {
  //     if (cart.length > 1)
  //       return `${cart[0].product_name} 외 ${cart.length - 1}개`;
  //     return cart[0].product_name;
  //   }
  //   return "상품";
  // };

  // const playChatTTS = async () => {
  //   if (window.ccOS) {
  //     ttsInstance.speak("주문내역 확인 후 결제해주세요");
  //   }
  // };

  const playChatTTS = () => {
    if (!isLoading) {
      const speechConfig = speechsdk.SpeechConfig.fromSubscription(
        process.env.REACT_APP_AZURE_KEY,
        process.env.REACT_APP_AZURE_REGION
      );
      speechConfig.speechSynthesisVoiceName = "ko-KR-YuJinNeural";

      const audioConfig = speechsdk.AudioConfig.fromDefaultSpeakerOutput();
      const synthesizer = new speechsdk.SpeechSynthesizer(
        speechConfig,
        audioConfig
      );

      const ssml = `
      <speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" xml:lang="en-US">
        <voice name="${speechConfig.speechSynthesisVoiceName}">
          <prosody rate="1.2">
            ${"주문내역 확인 후 결제해주세요"}
          </prosody>
        </voice>
      </speak>
    `;

      synthesizer.speakSsmlAsync(
        ssml,
        (result: SynthesisResult) => {
          console.log("result", result);
          if (
            result.reason === speechsdk.ResultReason.SynthesizingAudioCompleted
          ) {
            setTimeout(() => {
              console.log("end");
              synthesizer.close();
            }, 16 * 200);
          }
          // setIsSpeaking(false);
          // synthesizer.close();
        },
        (error: string) => {
          console.error(error);
          synthesizer.close();
        }
      );
    }
  };

  // useEffect(() => {
  //   if (window.ccOS) {
  //     window.ccOS.TextToSpeech.getInstance().then((instance: any) => {
  //       setTtsInstance(instance);
  //     });
  //   }
  // }, []);

  // useEffect(() => {
  //   if (ttsInstance !== null && cart.length > 0) {
  //     playChatTTS();
  //   }
  // }, [ttsInstance, cart]);

  useEffect(() => {
    if (chat && cart.length > 0) {
      playChatTTS();
    }
  }, [chat, cart]);

  // API 호출
  const getStoreInfo = async () => {
    try {
      const oParams = {
        store_id: storeId,
      };
      const oRes = await StoreController.getMenu(oParams);

      if (oRes && oRes.data) {
        console.log("getMenu", oRes.data);
        setStoreInfo(oRes.data.content);
        if (oRes.data.content.store_stamp.length > 0)
          setStamps([
            ...new Array(
              oRes.data.content.store_stamp[0].completion_value
            ).fill(false),
          ]);
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };

  const getStamp = async () => {
    try {
      const oParams = {
        page: 0,
      };
      const oRes = await UserController.getStamps(oParams);

      if (oRes && oRes.data) {
        console.log("getStamps", oRes.data);
        if (
          oRes.data.user_stamps &&
          stamps &&
          oRes.data.user_stamps.filter((item: any) => item.store_id === storeId)
            .length > 0
        ) {
          for (
            let i = 0;
            i <
            oRes.data.user_stamps.filter(
              (item: any) => item.store_id === storeId
            )[0].collected_stamp;
            i++
          ) {
            stamps[i] = true;
          }
          setStamps([...stamps]);
        }
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };
  const getStampCoupon = async () => {
    try {
      const oParams = {
        store_id: storeId,
      };
      const oRes = await UserController.getStampCoupons(oParams);

      if (oRes && oRes.data) {
        console.log("getStampCoupons", oRes.data);
        setStampCoupons([...oRes.data.coupons]);
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };
  const getCoupon = async () => {
    try {
      setIsLoading(true);
      const oParams = {
        store_id: storeId,
      };
      const oRes = await UserController.getCoupons(oParams);

      if (oRes && oRes.data) {
        console.log("getCoupons", oRes.data);
        setPointAvailable(true);
        setCoupons([...oRes.data.coupons]);
        if (oRes.data.auto_use_coupon) {
          setUsingCoupon(oRes.data.auto_use_coupon);
        }
        setIsLoading(false);
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };
  const getPoint = async () => {
    try {
      const oParams = {
        points_only: true,
      };
      const oRes = await UserController.getPoints(oParams);

      if (oRes && oRes.data) {
        console.log("getPoints", oRes.data);
        setPoint(Number(oRes.data.points));
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };
  const getCard = async () => {
    try {
      const oRes = await CardController.cardList();

      if (oRes && oRes.data) {
        console.log("cardList", oRes.data);
        setCards([...oRes.data.list]);
        if (oRes.data.list.find((item: CardType) => item.is_default === 1)) {
          setUsingCard(
            oRes.data.list.find((item: CardType) => item.is_default === 1)
          );
        } else setUsingCard(oRes.data.list[0]);
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };
  const setMainCard = async (item: CardType) => {
    try {
      const oParams = {
        card_id: item.ccard_id,
      };
      const oRes = await CardController.cardSetMain(oParams);

      if (oRes && oRes.data && oRes.data.success) {
        console.log("cardSetMain", oRes.data);
        setUsingCard(item);
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };
  const getArrivalTime = async () => {
    try {
      const oParams = {
        store_id: storeId,
        user_lat: position.lat,
        user_lng: position.lng,
        fix: true,
      };
      const oRes = await UserController.getOrderAndArrivalTime(oParams);

      if (oRes && oRes.data) {
        console.log("getOrderAndArrivalTime", oRes.data);
        setArrivalTime(
          oRes.data.store_availability === "closed" ||
            oRes.data.store_availability === "paused"
            ? oRes.data.store_availability_msg
            : oRes.data.user_arrival
        );
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };

  const onChange_usingPoint = (e: any) => {
    setUsingPoint(e.target.value);
  };
  // 픽업시간
  const handleMinusClick = () => {
    if (arrivalTime && !isNaN(Number(arrivalTime))) {
      setArrivalTime(String(Math.max(Number(arrivalTime) - 5, 5)));
    }
  };
  const handlePlusClick = () => {
    if (arrivalTime && !isNaN(Number(arrivalTime))) {
      setArrivalTime(String(Math.min(Number(arrivalTime) + 5, 120)));
    }
  };

  const getCartData = async () => {
    const reorderData = await AsyncLocalStorage.getItem("reorder");
    if (reorderData) {
      console.log("reorder cart", reorderData);
      setCart(reorderData.data);
      setStoreId(reorderData.store_id);
    } else {
      const cartData = await AsyncLocalStorage.getItem("cart");
      if (cartData) {
        console.log("cart", cartData);
        setCart(cartData.data);
        setStoreId(cartData.store_id);
      } else {
        // showToast("이미 완료된 주문이에요", "error");
        navigate("/home", { replace: true });
      }
    }
  };

  const getProductTotalPrice = (item: orderDetailRealmType) => {
    let totalPrice = 0;
    totalPrice += item.product_org_price;
    item.options.map((option) => {
      totalPrice += Number(option.option_price);
    });
    return totalPrice;
  };

  const getCartTotalPrice = () => {
    let totalPrice = 0;
    if (cart && cart.length > 0) {
      cart.map((item) => {
        totalPrice += getProductTotalPrice(item) * item.product_quantity;
      });
    }
    return totalPrice;
  };

  const useMaximumPoint = () => {
    if (usingPoint === "" && pointAvailable) {
      const totalPrice = getCartTotalPrice();
      setUsingPoint(
        totalPrice - discount > 0
          ? totalPrice - discount > point
            ? String(point)
            : String(totalPrice - discount)
          : "0"
      );
      setPoint(
        totalPrice - discount > 0
          ? totalPrice - discount > point
            ? 0
            : point - (totalPrice - discount)
          : point
      );
    } else {
      setUsingPoint("");
      setPoint(point + Number(usingPoint));
    }
  };

  const checkMaximumPoint = () => {
    const totalPrice = getCartTotalPrice();
    if (Number(usingPoint) > totalPrice - discount) {
      setUsingPoint(
        totalPrice - discount > 0
          ? totalPrice - discount > point
            ? String(point)
            : String(totalPrice - discount)
          : "0"
      );
      setPoint(
        totalPrice - discount > 0
          ? totalPrice - discount > point
            ? 0
            : point - (totalPrice - discount)
          : point
      );
    }
  };

  const openCardModal = () => {
    if (cards.length > 0)
      setCardOpen({
        visibleConfirm: true,
        handleConfirm: setMainCard,
        modalData: { cards: cards, usingCard: usingCard },
      });
    else showToast("카드를 등록해주세요", "error");
  };
  const openStampCouponModal = () => {
    if (stampCoupons.length > 0) {
      if (usingStamp) {
        setUsingStamp(undefined);
      } else {
        setStampCouponOpen({
          visibleConfirm: true,
          handleConfirm: setUsingStamp,
          modalData: {
            coupons: stampCoupons,
            usingCoupon: usingStamp,
            totalPrice: getCartTotalPrice(),
          },
        });
      }
    } else showToast("사용 가능한 선불권이 없어요", "error");
  };
  const openCouponModal = () => {
    if (coupons.length > 0) {
      if (usingCoupon) {
        setUsingCoupon(undefined);
      } else {
        setCouponOpen({
          visibleConfirm: true,
          handleConfirm: setUsingCoupon,
          modalData: {
            coupons: coupons,
            usingCoupon: usingCoupon,
            totalPrice: getCartTotalPrice(),
          },
        });
      }
    } else showToast("사용 가능한 쿠폰이 없어요", "error");
  };

  const getOrderPrdKey = (index: number, prd_id: number, option: number[]) => {
    let orderPrdKey: string = `${(index + 1)
      .toString()
      .padStart(4, "0")}:s${storeId}:p${prd_id}`;

    let optionKey: string = "";
    option.map((item: number) => {
      optionKey += "-" + item;
    });
    if (optionKey.length > 0) {
      optionKey = optionKey.slice(1);
      orderPrdKey += ":o" + optionKey;
    }
    return orderPrdKey;
  };

  const getPaymentOptionList = () => {
    const dataName = `store-id-${storeId}`;
    let optionListTemp: { [key: string]: any } = {};
    let arrayData: any = [];

    if (cart && cart.length > 0) {
      cart.map((item: orderDetailRealmType, index: number) => {
        let optionData: number[] = [];
        item.options.map((option: orderDetailOptionType) => {
          optionData.push(option.option_id);
        });

        const trayTemp = {
          prd_name: item.product_name,
          quantity: item.product_quantity,
          inquiry: "",
          prd_id: item.product_id,
          total_price: item.product_total_amount * item.product_quantity,
          order_prd_key: getOrderPrdKey(index, item.product_id, optionData),
          options: optionData,
        };
        arrayData.push(trayTemp);
      });
    }
    optionListTemp[dataName] = arrayData;
    return optionListTemp;
  };

  const navigateOrder = () => {
    if (!isNaN(Number(arrivalTime))) {
      if (!usingCard) {
        showToast("등록된 카드가 없어요", "error");
      } else if (
        getCartTotalPrice() - discount - Number(usingPoint) < 500 &&
        getCartTotalPrice() - discount - Number(usingPoint) !== 0
      ) {
        showToast("500원부터 결제 가능해요", "error");
      } else {
        console.log("order position", position);

        const orderData = {
          payment_type: "QUICK",
          payment_method: "",
          payment_basket: getPaymentOptionList(),
          payment_basket_subtotal_price: getCartTotalPrice(),
          payment_basket_total_price:
            getCartTotalPrice() - discount - Number(usingPoint),
          payment_store_id: storeId,
          payment_order_pickup_type: "driving",
          payment_order_pickup_speed: "normal",
          payment_phone_number: "01012341234", // test
          payment_license_number: "123가1234", // test
          payment_longitude: position.lng,
          payment_latitude: position.lat,
          payment_point_used: Number(usingPoint),
          payment_point_yn: Number(usingPoint) > 0,
          payment_user_coupon_id: usingCoupon ? usingCoupon.user_coupon_id : 0,
          payment_user_coupon_yn: usingCoupon ? true : false,
          payment_stamp_coupon_id: 0, // test
          payment_stamp_coupon_yn: false, // test
          payment_coupon_id: usingCoupon ? usingCoupon.coupon_id : 0,
          payment_coupon_yn: usingCoupon ? true : false,
          payment_coupon_code: "",
          payment_inquiry: "",
          payment_arrival_time: Number(arrivalTime),
          payment_deviceuuid: "",
          payment_user_devicenfo: "",
        };
        navigate("/payment/password", { state: { orderData } });
      }
    }
  };

  // const orderCart = async () => {
  //   console.log("storeId", storeId);
  //   try {
  //     const oParams = {
  //       payment_type: "QUICK",
  //       payment_method: "",
  //       payment_basket: getPaymentOptionList(),
  //       payment_basket_subtotal_price: getCartTotalPrice(),
  //       payment_basket_total_price:
  //         getCartTotalPrice() - discount - Number(usingPoint),
  //       payment_store_id: storeId,
  //       payment_order_pickup_type: "driving",
  //       payment_order_pickup_speed: "normal",
  //       payment_phone_number: "01012341234", // test
  //       payment_license_number: "123가1234", // test
  //       payment_longitude: position.lng,
  //       payment_latitude: position.lat,
  //       payment_point_used: Number(usingPoint),
  //       payment_point_yn: Number(usingPoint) > 0,
  //       payment_user_coupon_id: usingCoupon ? usingCoupon.user_coupon_id : 0,
  //       payment_user_coupon_yn: usingCoupon ? true : false,
  //       payment_stamp_coupon_id: 0, // test
  //       payment_stamp_coupon_yn: false, // test
  //       payment_coupon_id: usingCoupon ? usingCoupon.coupon_id : 0,
  //       payment_coupon_yn: usingCoupon ? true : false,
  //       payment_coupon_code: "",
  //       payment_inquiry: "",
  //       payment_arrival_time: arrivalTime,
  //       payment_deviceuuid: "",
  //       payment_user_devicenfo: "",
  //     };
  //     const oRes = await OrderController.newOrder(oParams);

  //     console.log("newOrder", oRes.data);

  //     if (oRes && oRes.data) {
  //       let data: any = null;
  //       if (oRes.data.ok) {
  //         data = {
  //           type: "confirm",
  //           data: oParams,
  //         };
  //       } else {
  //         data = {
  //           type: "error",
  //           data: null,
  //         };
  //         showToast(`${oRes.data.result_msg}`, "error");
  //       }
  //       AsyncLocalStorage.removeItem("cart");
  //       AsyncLocalStorage.removeItem("reorder");
  //       window.parent.postMessage(data, "*");
  //       console.log("order post", data);
  //     }
  //   } catch (err) {
  //     console.log("err---->", err);
  //   }
  // };

  // const receiveData = (event: any) => {
  //   const receivedData = event.data;
  //   if (receivedData.type === "payment") {
  //     setIframePay(receivedData.data);
  //     console.log("post!!", receivedData);
  //   }
  // };

  useEffect(() => {
    // window.addEventListener("message", receiveData);
    return () => {
      // window.removeEventListener("message", receiveData);
      AsyncLocalStorage.removeItem("reorder");
    };
  }, []);

  useEffect(() => {
    if (position && storeId) {
      getArrivalTime();
    }
  }, [position, storeId]);

  // useEffect(() => {
  //   if (iframePay === "true") {
  //     orderCart();
  //   }
  // }, [iframePay]);

  useEffect(() => {
    getCartData();
  }, []);

  useEffect(() => {
    if (storeId) {
      getStoreInfo();
      getCard();
      getCoupon();
      getPoint();
      getStampCoupon();
    }
  }, [storeId]);

  useEffect(() => {
    if (storeInfo) {
      getStamp();
    }
  }, [storeInfo]);

  useEffect(() => {
    if (isGuide) {
      setTimeout(() => {
        setIsGuide(false);
      }, 3000);
    }
  }, [isGuide]);

  useEffect(() => {
    let discountPrice = 0;
    if (usingCoupon) {
      discountPrice +=
        Number(usingCoupon.price) > 0
          ? Number(usingCoupon.price)
          : (getCartTotalPrice() * Number(usingCoupon.percent)) / 100 >
            Number(usingCoupon.max_discount)
          ? Number(usingCoupon.max_discount)
          : (getCartTotalPrice() * Number(usingCoupon.percent)) / 100;
    }
    if (usingStamp) {
      discountPrice +=
        discount + Number(usingStamp.price) > 0
          ? Number(usingStamp.price)
          : (getCartTotalPrice() * Number(usingStamp.percent)) / 100 >
            Number(usingStamp.max_discount)
          ? Number(usingStamp.max_discount)
          : (getCartTotalPrice() * Number(usingStamp.percent)) / 100;
    }
    setDiscount(discountPrice);
  }, [usingCoupon, usingStamp]);

  const RenderCartItem = useMemo(() => {
    return (
      <div className="listWrap">
        {cart &&
          cart.length > 0 &&
          cart.map((item, index) => {
            return (
              <div className="list" key={index}>
                <div key={index} className="item">
                  <h1 className="name">{item.product_name}</h1>
                  <h1>{item.product_quantity}건</h1>
                  <h1 className="price">
                    {getProductTotalPrice(item).toLocaleString()}원
                  </h1>
                </div>
                {item.options.map((option, optionIdx) => {
                  return (
                    <div className="item" key={optionIdx}>
                      <h2 className="name">&#8627; {option.option_name}</h2>
                      <h2 className="price">
                        {Number(option.option_price).toLocaleString()}원
                      </h2>
                    </div>
                  );
                })}
              </div>
            );
          })}
      </div>
    );
  }, [cart]);

  return (
    <>
      <Style>
        <div className="wrapper">
          <div className="leftWrap">
            <div className="contentWrap">
              <h2>주문내역</h2>
              <div className="cartList">
                {RenderCartItem}
                <div>
                  <div className="totalList discount flexSpaceBetween">
                    <h1>할인금액</h1>
                    <h1>
                      {(discount + Number(usingPoint)).toLocaleString()}원
                    </h1>
                  </div>
                  <div className="totalList flexSpaceBetween">
                    <h1>합계</h1>
                    <h1>
                      {(
                        getCartTotalPrice() -
                        discount -
                        Number(usingPoint)
                      ).toLocaleString()}
                      원
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div className="pickupTime">
              <div className="buttonsWrap">
                <button onClick={handleMinusClick}>
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_minus.svg`}
                    alt="minus"
                  />
                </button>
                {arrivalTime && (
                  <div>
                    <h2>픽업시간</h2>
                    <h3>
                      {isNaN(Number(arrivalTime))
                        ? arrivalTime
                        : `${arrivalTime}분 뒤`}
                    </h3>
                  </div>
                )}
                <button onClick={handlePlusClick}>
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`}
                    alt="plus"
                  />
                </button>
              </div>
            </div>
          </div>
          <div className="rightWrap">
            <div className="paymentWrap">
              <div className="contentWrap rowpan">
                <div className="row">
                  <h2>결제수단</h2>
                  <div className="guideTextWrap flexStart">
                    <img
                      onClick={() => setIsGuide(true)}
                      src={`${process.env.PUBLIC_URL}/svg/ic_important.svg`}
                      alt="안내사항 아이콘"
                    />
                    <p className={`${isGuide && "active"}`}>
                      결제수단은 스루 앱에서 추가해주세요
                    </p>
                  </div>
                </div>
                <div className="textWrap flexStart">
                  {usingCard ? (
                    <>
                      <h3 className="cardName">
                        {usingCard.ccard_name_show === ""
                          ? usingCard.ccard_company.replace(
                              /\[([^\]]+)\]카드/g,
                              "$1"
                            )
                          : usingCard.ccard_name_show}
                      </h3>
                      <h3>{usingCard.number}</h3>
                    </>
                  ) : (
                    <h3>카드를 선택해주세요</h3>
                  )}
                  <button onClick={openCardModal}>카드선택</button>
                </div>
              </div>
              {stampCoupons.length > 0 ? (
                <div className="contentWrap">
                  <h2>선불권</h2>
                  <div className="textWrap">
                    <h3>
                      {usingStamp
                        ? usingStamp.name
                        : `총 ${
                            stampCoupons.filter(
                              (item) =>
                                getCartTotalPrice() >= Number(item.requirement)
                            ).length
                          }장의 선불권이 있어요`}
                    </h3>
                    <button
                      className={`${usingStamp && "inactive"}`}
                      onClick={openStampCouponModal}
                    >
                      {usingStamp ? "사용해제" : "선불권 사용"}
                    </button>
                  </div>
                </div>
              ) : (
                stamps && (
                  <div className="contentWrap">
                    <h2>스탬프</h2>
                    <div className="textWrap">
                      <div className="row">
                        {stamps.map((item, index) => (
                          <img
                            key={index}
                            src={`${process.env.PUBLIC_URL}/svg/ic_stamp${
                              item ? "" : "_none"
                            }.svg`}
                            alt="stamp"
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                )
              )}
              <div className="contentWrap">
                <h2>할인쿠폰</h2>
                <div className="textWrap">
                  <h3>
                    {usingCoupon ? usingCoupon.name : "쿠폰을 선택해주세요"}
                  </h3>
                  <button
                    className={`${usingCoupon && "inactive"}`}
                    onClick={openCouponModal}
                  >
                    {usingCoupon ? "사용해제" : "쿠폰선택"}
                  </button>
                </div>
              </div>
              <div className="contentWrap">
                <h2>포인트</h2>
                <div className="inputWrap point">
                  <input
                    type="number"
                    value={usingPoint}
                    placeholder={`${point.toLocaleString()} 포인트`}
                    onChange={onChange_usingPoint}
                    onBlur={checkMaximumPoint}
                  />
                  <button
                    className={`${Number(usingPoint) > 0 && "inactive"}`}
                    onClick={useMaximumPoint}
                  >
                    {Number(usingPoint) > 0 ? "사용해제" : "전체사용"}
                  </button>
                </div>
              </div>
            </div>
            <div className="rowpan payButton">
              <button
                className={`successButton ${
                  isNaN(Number(arrivalTime)) && "inactive"
                }`}
                onClick={navigateOrder}
              >
                결제하기
              </button>
            </div>
          </div>
        </div>
        {isLoading && <Spinner />}
      </Style>
      <RecoilCardModal />
      <RecoilCouponModal />
      <RecoilStampCouponModal />
    </>
  );
};

export default OrderPayment;

const Style = styled.div`
  .wrapper {
    width: 100vw;
    height: 100vh;
    padding: 5vh;
    display: flex;
    align-items: flex-start;
    gap: 5vh;
  }
  h1 {
    font-weight: 500;
  }
  h2 {
    margin: 1vh 0;
    font-size: 3.5vh;
    font-weight: 500;
  }
  button {
    width: auto;
  }

  /* leftWrap/rightWrap */
  .leftWrap,
  .rightWrap {
    max-width: ((96vw - 5vh) / 2);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    flex: 1;
  }

  .leftWrap {
    .cartList {
      max-height: 66vh;
      min-height: 66vh;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border: 1px solid #a7a7a7;
      border-radius: 10px;

      .listWrap {
        overflow-y: scroll;
      }
      .list {
        padding: 3vh 5vh;
        border-bottom: 1px solid #414141;
        h2 {
          font-weight: 400;
        }
        .item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          text-align: right;
          .name {
            width: 40%;
            text-align: left;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .price {
            width: 20%;
          }
        }
      }
    }
    .totalList {
      padding: 2.5vh 5vh;
      background: #242424;
      border-top: 1px solid #a7a7a7;
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    .totalList.discount {
      background: #000000;
      border-radius: 0;
    }
  }

  .rightWrap {
    .paymentWrap {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      max-height: 71.5vh;
      min-height: 71.5vh;
    }
  }

  /* contentWrap */
  .contentWrap {
    .textWrap,
    .inputWrap {
      width: 100%;
      position: relative;
      padding: 3vh 4vh;
      border-radius: 10px;
      border: 1px solid #a7a7a7;
      h3 {
        width: auto;
        font-size: 4vh;
        line-height: 4vh;
        font-weight: 500;
      }
      h3.cardName {
        width: 30%;
      }
      img {
        height: 40px;
      }
      button {
        position: absolute;
        right: 0;
        top: 0;
        width: 11vw;
        height: 100%;
        background: #3d4779;
        font-size: 4vh;
        line-height: 4vh;
        font-weight: 600;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }
      button.inactive {
        background: #333333;
        color: #a7a7a7;
      }
    }
    .inputWrap {
      input {
        width: 70%;
        background: #000;
        border-radius: 10px;
        padding: 0;
        font-size: 4vh;
        line-height: 4vh;
        color: #fff;
      }
    }
    .row {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }

  /* guideTextWrap */
  .guideTextWrap {
    margin: 1vh 0;
    img {
      width: 3vh;
      margin-right: 1.5vh;
    }
    p {
      font-size: 2.5vh;
      line-height: 3.5vh;
      font-weight: 500;
      color: #ffffff;
      padding: 0 16px;
      background: #ff5959;
      border-radius: 50px;
      opacity: 0;
      transition: opacity 0.15s ease-out;
    }
    p.active {
      opacity: 1;
    }
  }

  /* buttonsWrap */
  .buttonsWrap {
    margin-top: 5vh;
    display: flex;
    align-items: center;
    justify-content: space-between;

    button {
      padding: 0 6vh;
      height: 12vh;
      border: 1px solid #a7a7a7;
      border-radius: 10px;
    }
    img {
      width: 6vh;
      height: 6vh;
    }
    h2 {
      text-align: center;
      margin-top: -6px;
    }
    h3 {
      font-size: 5vh;
      font-weight: 500;
      text-align: center;
    }
  }
  /* 결제하기버튼 */
  .payButton {
    margin-top: 5vh;
    .successButton {
      width: 100%;
      height: 12vh;
    }
    .successButton.inactive {
      background: #a7a7a7;
    }
    .contentWrap:nth-last-child(1) {
      margin-top: auto;
    }
  }
  @media (max-width: 1400px) {
    h2 {
      margin: 1vh 0;
      font-size: 40px;
      font-weight: 500;
    }
    .wrapper {
      height: 100%;
      min-height: 100vh;
      flex-direction: column;
      gap: 10px;
    }
    .leftWrap {
      width: 100%;
      height: 100%;
      flex: 1;

      .cartList {
        flex: 1;
        min-height: 30vh;
        max-height: 30vh;

        .listWrap {
          .list {
            padding: 24px;
          }
        }
      }
    }
    .buttonsWrap {
      margin-top: 20px;

      button {
        padding: 20px;
        border: 1px solid #a7a7a7;
        border-radius: 10px;
        height: auto;
      }
      img {
        width: 50px;
        height: 50px;
      }
      h2 {
        margin-top: 0;
        font-size: 30px;
      }
      h3 {
        font-size: 40px;
      }
    }

    .rightWrap {
      width: 100%;
      height: 30vh;

      .paymentWrap {
        max-height: auto;
        min-height: auto;
      }
    }
    .contentWrap {
      .inputWrap,
      .textWrap {
        padding: 20px;
        input,
        h3 {
          font-size: 30px;
        }
        button {
          width: auto;
          padding: 0 26px;
          font-size: 30px;
        }
      }
    }
  }
  .payButton {
    margin-top: 20px;

    .successButton {
      height: auto;
      padding: 24px 0;
    }
  }
  .guideTextWrap {
    img {
      width: 2vh;
    }
  }
`;
